<template>
  <section class="main-container">
    <div class="main-container__container">
      <Tops :custom="colorsConfig" />
    </div>
  </section>
</template>

<script>
import Tops from '@/views/TopsV2';
export default {
  name: 'landing',
  components: { Tops },
  data() {
    return {
      colorsConfig: {
        logo: 'https://golstatsimages.blob.core.windows.net/content/escudo_golstats.png',
        color: '#cbee6b',
        background: '#242424',
        colorheader: '#132839',
        backgroundheader: '#CCE8B5',

        headerBackground: '#132839',
        headerColor: '#CBEE6E',
        headerBorderColor: '#CBEE6E',

        header2Background: '#132839',
        header2Color: '#FFFFFF',

        subHeaderBackground: '#cbee6b',
        subHeaderColor: '#353535',

        //bettool
        headerBetToolBackground: '#242424',
        subheaderBetToolBackground: '#151515',

        bet_house: '',
        main_logo: '',
        secondary_logo: '',
        show_logo: false,
        url_base: '',

        type: 1,
        team_id: 0,
        categories: 'all',
      },
    };
  },

  watch: {},
  async created() {},
};
</script>

<style lang="scss" scoped>
.main-container {
  display: inline-block;
  margin: 0 auto;
  margin-top: 12px;
  max-width: 2000px;
  padding-bottom: 70px;
  width: 96.2%;
  border-radius: 21px;
  box-shadow: 0 7px 24px 0 rgba(84, 124, 171, 0.12);
  background-color: #ffffff;
  &__container {
    width: 1270px;
    height: auto;
    margin: 0 auto;
    margin-top: 19px;
    @media screen and (max-width: 1328px) {
      width: 98%;
    }
  }
}
</style>
